'use client';

import { WebViewEventParams, WebViewEventType } from '@diritto/common/app/webview-event.constant';
import { HeaderNavMenu, WebViewTitle } from '@diritto/common/app/webview-header.constant';
import { DirittoAppBridge } from 'libs/DirittoAppBridge';
import { useEffect } from 'react';
import { useClient } from 'ui-hooks/useClient';

export const useInAppHeader = (params: WebViewEventParams[WebViewEventType.ShowAppHeader]) => {
  const client = useClient();

  useEffect(() => {
    if (client.isApp) {
      DirittoAppBridge.showAppHeader({
        title: WebViewTitle[params.screen],
        ...params,
        leftMenuList: params.leftMenuList ?? [HeaderNavMenu.Back, HeaderNavMenu.Home],
      });
    }
  }, [client.isApp, params]);
};
